import React, { useState, useEffect, useContext, useRef } from "react";
import { IconButton, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle, Button, Badge } from "@mui/material";
import "react-tabs/style/react-tabs.css";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import EmployeeProfile from "area/employer/EmployeeCensus/EmployeeProfile";
import EmployeeEmployment from "area/employer/EmployeeCensus/EmployeeEmployment";
import EmployeeBenefits from "area/employer/EmployeeCensus/EmployeeBenefits";
import AddEmployeeBenefits from "area/employer/EmployeeCensus/AddEmployeeBenefits";
import * as Yup from 'yup';

function EmployeeBenefitsMenu(props) {
  const profileRef = useRef({});
  const employmentRef = useRef({});
  const benefitsRef = useRef({});
  const addBenefitsRef = useRef({});

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [openModal, setOpen] = useState(false);
  const [openProfileModal, setOpenProfileModal] = useState(false);
  const [fetchedProfileData, setFetchedProfileData] = useState(null);

  const [openEmploymentModal, setOpenEmploymentModal] = useState(false);
  const [fetchedEmploymentData, setFetchedEmploymentData] = useState(null);

  const [openBenefitsModal, setOpenBenefitsModal] = useState(false);
  const [fetchedBenefitsData, setFetchedBenefitsData] = useState(null);

  const [openAddBenefitsModal, setAddOpenBenefitsModal] = useState(false);
  const [fetchedAddBenefitsData, setFetchedAddBenefitsData] = useState(null);

  const [profileErrors, setProfileErrors] = useState({});
  const [employmentErrors, setEmploymentErrors] = useState({});
  const handleProfileEdit = () => {
    console.log("handleProfileEdit", props.employeeID);
    setFetchedProfileData(props.employee);
    setProfileErrors({});
    setOpenProfileModal(true);
    setAnchorEl(null);
    setOpen(false);

    //fetch data
    // let storedCompanyId = localStorage.getItem(`selectedCompanyId`);
    // apiGet(apiUrls.getEmpView(props.employeeID)).then(
    //   (empResponse) => {
    //     console.dir('emp response');
    //     console.dir(empResponse);
    //     setFetchedProfileData(empResponse.data);
    //     setOpenProfileModal(true);
    //     setAnchorEl(null);
    //     setOpen(false);
    //   });

  };
  const handleProfileClose = () => {
    setOpenProfileModal(false)
  };

  const profileValidationSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required')
      .max(50, 'First Name must not exceed 50 characters'),
    lastName: Yup.string().required('Last Name is required')
      .max(50, 'Last Name must not exceed 50 characters'),
    ssn: Yup.string().required('SSN is required')
      .max(11, 'SSN must not exceed 10 characters')
      .required(),
    birthDate: Yup.date().min('1901-01-01').typeError('Birth date is required'),
    email: Yup.string().email().required(),
  });

  const employmentValidationSchema = Yup.object().shape({
    hourlySalary: Yup.number().min(0, 'Must be greater than 0').typeError('Invalid number'),
    weeklySalary: Yup.number().min(0, 'Must be greater than 0').typeError('Invalid number'),
    annualSalary: Yup.number().min(0, 'Must be greater than 0').typeError('Invalid number'),
    beginDate: Yup.date().min('1901-01-01').typeError('Begin date is required'),
    endDate: Yup.date().min('1901-01-01').typeError('End date is required'),
    hireDate: Yup.date().min('1901-01-01').typeError('Hire date is required').required(),
    employmentStatusID: Yup.number().min(1, 'Status is required').required('Status is required'),
    employeeGroupID: Yup.string().notOneOf(['00000000-0000-0000-0000-000000000000'], 'Employee Group is required').required('Employee Group is required'),
  });
  const handleSaveEmployeeProfile = async () => {
    console.log("handleProfile save", props.employeeID);
    if (profileRef != null && profileRef.current.formData !== undefined) {
      let formData = profileRef.current.formData;
      const newProfile = {
        "birthDate": formData.birthDate,
        "email": formData.email,
        "firstName": formData.firstName,
        "genderID": formData.genderID,
        "insuredID": fetchedProfileData.insuredID,
        "lastName": formData.lastName,
        "mailingAddress1": formData.mailingAddress1,
        "mailingAddress2": formData.mailingAddress2,
        "mailingCity": formData.mailingCity,
        "mailingStateID": formData.mailingStateID,
        "mailingZipCode": formData.mailingZipCode,
        "maritalStatusID": formData.maritalStatusID,
        "middleName": formData.middleName,
        "ssn": formData.ssn,
        "workPhone": formData.workPhone,
        "homePhone": formData.homePhone,
      }

      try {
        const valid = await profileValidationSchema.validateSync(newProfile,
          { abortEarly: false }
        );
        console.log(valid, 'valid')
        props.handleProfileSave(props.employeeID, newProfile)

      } catch (error) {
        // error.inner
        //console.log(error,'valid error')
        let pErrors = {};
        for (const err of error.inner) {
          if (err.path) {
            console.log(err.path, 'err.path')
            console.log(err.message, 'err.message')
            Object.defineProperty(pErrors, err.path, {
              value: err.message,
              writable: true
            });
            //pErrors[error.path] = error.message;
          }
        }

        console.dir(pErrors, 'pErrors')
        setProfileErrors(pErrors)
      }

    }
  }

  const handleEmploymentEdit = () => {
    console.log("handleEmploymentEdit:", props.employeeID);
    // props.handleEmploymentEdit(props.employeeID)

    setFetchedEmploymentData(props.employee);
    setOpenEmploymentModal(true);
    setAnchorEl(null);
    setOpen(false);

    setEmploymentErrors({})
    //fetch from server
    // let storedCompanyId = localStorage.getItem(`selectedCompanyId`);
    // apiGet(apiUrls.getEmpView(props.employeeID)).then(
    //   (empResponse) => {
    //     console.dir('emp response');
    //     console.dir(empResponse);
    //     setFetchedEmploymentData(empResponse.data);
    //     setOpenEmploymentModal(true);
    //     setAnchorEl(null);
    //     setOpen(false);
    //   });
  };

  const handleEmploymentClose = () => {
    setOpenEmploymentModal(false)
  };

  const handleSaveEmployeeEmployment = async () => {
    console.log("handleEmployment save", props.employeeID);
    console.log(employmentRef, "employmentRef ");
    if (employmentRef.current.formData !== undefined) {
      console.log("saving");
      let formData = employmentRef.current.formData;
      const newEmployment = {
        "annualSalary": formData.annualSalary,
        "benefitPackageID": formData.benefitPackageID,
        "department": formData.department,
        "division": formData.division,
        "beginDate": formData.effectiveDateOfChange,
        //"endDate": formData.effectiveDateOfChange,
        "effectiveDateOfChange": formData.effectiveDateOfChange,
        "employeeAltKey": formData.employeeAltKey,
        "employeeGroupID": formData.employeeGroupID,
        "employeeID": formData.employeeID,
        "employeeNotes": formData.employeeNotes,
        "employmentStatusID": formData.employmentStatusID,
        "hireDate": formData.hireDate,
        "hourlySalary": formData.hourlySalary,
        "jobClass": formData.jobClass,
        "jobTitle": formData.jobTitle,
        "location": formData.location,
        "locationCode": formData.locationCode,
        "rehireDate": formData.rehireDate,
        "serviceCreditDate": formData.serviceCreditDate,
        "termDate": formData.termDate,
        "weeklySalary": formData.weeklySalary
      }

      try {
        const valid = await employmentValidationSchema.validateSync(newEmployment,
          { abortEarly: false }
        );
        console.log(valid, 'valid')
        props.handleEmploymentSave(props.employeeID, newEmployment)

      } catch (error) {
        // error.inner
        console.log(error, 'valid error')
        let pErrors = {};
        if (error.inner) {
          for (const err of error.inner) {
            if (err.path) {
              Object.defineProperty(pErrors, err.path, {
                value: err.message,
                writable: true
              });
              //pErrors[error.path] = error.message;
            }
          }

          console.dir(pErrors, 'pErrors')
          setEmploymentErrors(pErrors)
        }
      }


    }
  }

  const handleBenefitEdit = () => {
    console.log("handleBenefitEdit employeeID:", props.employeeID);
    console.log("handleBenefitEdit insuredID:", props.insuredID);
    console.log("handleBenefitEdit hwBenefitDate:", props.hwBenefitDate);
    console.log("props.employee.benefitEnrollments", props.employee.benefitEnrollments);

    if (props.employee.benefitEnrollments != null && props.employee.benefitEnrollments.length > 0) {
      setFetchedBenefitsData(props.employee.benefitEnrollments);
      setOpenBenefitsModal(true);
      setAnchorEl(null);
      setOpen(false);
    }
    else {
      //fetch from server
      console.log('fetching form server')
      let storedCompanyId = localStorage.getItem(`selectedCompanyId`);
      apiGet(apiUrls.getEnrollments(props.insuredID, props.hwBenefitDate)).then(
        (empResponse) => {
          console.dir('emp enrollments response');
          console.dir(empResponse);
          setFetchedBenefitsData(empResponse.data);
          setOpenBenefitsModal(true);
          setAnchorEl(null);
          setOpen(false);
        });
    }
  };

  const handleBenefitClose = () => {
    setOpenBenefitsModal(false)
  };

  const handleSaveAddEmployeeBenefit = () => {
    console.log("handleBenefitEdit employeeID:", props.employeeID);
    console.log("handleBenefitEdit insuredID:", props.insuredID);
    console.log('handleSaveAddEmployeeBenefit')
    console.log(addBenefitsRef.current)
    if (addBenefitsRef != null && addBenefitsRef.current.formData !== undefined) {
      let formData = addBenefitsRef.current.formData;
      props.handleAddBenefitSave(props.employeeID, formData.filter(f => (f.toAdd == true)))
    }
  }

  const handleAddBenefitClose = () => {
    setAddOpenBenefitsModal(false)
  };

  const handleAddEmployeeBenefit = () => {
    console.log(props);
    console.log(props.insuredID, 'props.insuredID');
    console.log(props.benefitPackageID, 'props.benefitPackageID');
    let storedCompanyId = localStorage.getItem(`selectedCompanyId`);
    if (props.employee?.NewProfile?.Action == "New") {
      apiGet(apiUrls.getNewAvailableEnrollments(storedCompanyId, props.benefitPackageID, props.hwBenefitDate)).then(
        (benefitsResponse) => {
          console.log(benefitsResponse.data, 'emp handleAddEmployeeBenefit');
           setFetchedAddBenefitsData(benefitsResponse.data)
           setAddOpenBenefitsModal(true)
        });
    }
    else {
      apiGet(apiUrls.getAvailableEnrollments(storedCompanyId, props.insuredID, props.benefitPackageID, props.hwBenefitDate)).then(
        (benefitsResponse) => {
          console.log(benefitsResponse.data, 'emp handleAddEmployeeBenefit');
          setFetchedAddBenefitsData(benefitsResponse.data)
          setAddOpenBenefitsModal(true)
        });

    }
  }

  const handleSaveEmployeeBenefit = (newFormData) => {
    console.log("handleSaveEmployeeBenefit save", props.employeeID);
    console.log("handleSaveEmployeeBenefit newFormData", newFormData);
    // console.log('fetched data')
    // console.dir(fetchedProfileData)
    // console.dir(profileRef.current)
    // console.dir(profileRef.current.formData)
    // const newProfile = {
    //   "birthDate": profileRef.current.formData.birthDate,
    //   "email": profileRef.current.formData.email,
    //   "firstName": profileRef.current.formData.firstName,
    //   "GenderID": profileRef.current.formData.genderID,
    //   "homePhone": fetchedProfileData.homePhone,
    //   "insuredID": fetchedProfileData.insuredID,
    //   "lastName": profileRef.current.formData.lastName,
    //   "mailingAddress1": profileRef.current.formData.mailingAddress1,
    //   "mailingAddress2": profileRef.current.formData.mailingAddress2,
    //   "mailingCity": profileRef.current.formData.mailingCity,
    //   "mailingStateID": profileRef.current.formData.mailingStateID,
    //   "mailingZipCode": profileRef.current.formData.mailingZipCode,
    //   "maritalStatusID": profileRef.current.formData.maritalStatusID,
    //   "middleName": profileRef.current.formData.middleName,
    //   "ssn": profileRef.current.formData.ssn,
    //   "workPhone": fetchedProfileData.workPhone,
    // }
    props.handleBenefitSave(props.employeeID, newFormData)
  }

  const handleEmployeeReset = () => {
    console.log("handleReset:", props.employeeID);
    props.handleEmployeeReset(props.employeeID)
  };
  const handleClick = (event) => {
    const target = event.currentTarget;
    setAnchorEl(target);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };


  return <>
    <Badge color="secondary"
      badgeContent={((props.employee.Action == 'New' && props.employee.NewEmployment === undefined) ? "Missing Employment Info" : props.employee.ChangeType)}>
      <div>
        <Button
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
          size="large">
          Update
        </Button>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              width: "20ch",
            },
          }}
        >
          <MenuItem onClick={handleProfileEdit}>Profile</MenuItem>
          <MenuItem onClick={handleEmploymentEdit}>Employment</MenuItem>
          <MenuItem onClick={handleBenefitEdit}>Benefit</MenuItem>
          <MenuItem onClick={handleEmployeeReset}>Undo</MenuItem>
        </Menu>
      </div>
    </Badge>

    {/* MODAL */}
    {/* Profile Modal */}
    <Dialog
      open={openProfileModal}
      onClose={handleProfileClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={ModalStyles.empDataModal}
      maxWidth="lg"
    >
      <DialogTitle id="alert-dialog-title">
        Edit Employee Profile
      </DialogTitle>
      <DialogContent className={ModalStyles.CustomTabsWrapper}>

        {fetchedProfileData !== undefined ? (
          <form noValidate autoComplete="off" className="grid">
            <EmployeeProfile fetchedData={fetchedProfileData} ref={profileRef} states={props.states}
              maritalStatuses={props.maritalStatuses}
              genders={props.genders}
              errors={profileErrors}
            ></EmployeeProfile>
          </form>
        ) : (
          <h3>No Data Available</h3>
        )}
      </DialogContent>
      <DialogActions className={ButtonStyle.buttonWrapper}>
        <Button
          variant="outlined"
          onClick={handleSaveEmployeeProfile}
          className={ButtonStyle.CsubmitBtn}
        >
          Save
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          onClick={handleProfileClose}
          className={ButtonStyle.CcancelBtn}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>

    {/* Employment Modal */}
    <Dialog
      open={openEmploymentModal}
      onClose={handleEmploymentClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={ModalStyles.empDataModal}
      maxWidth="lg"
    >
      <DialogTitle id="alert-dialog-title">
        Edit Employee Employment
      </DialogTitle>
      <DialogContent className={ModalStyles.CustomTabsWrapper}>

        {fetchedEmploymentData !== undefined ? (
          <form noValidate autoComplete="off" className="grid">
            <EmployeeEmployment fetchedData={fetchedEmploymentData} ref={employmentRef} employmentStatus={props.employmentStatus} employeeGroups={props.employeeGroups}
              errors={employmentErrors}
            ></EmployeeEmployment>
          </form>
        ) : (
          <h3>No Data Available</h3>
        )}
      </DialogContent>
      <DialogActions className={ButtonStyle.buttonWrapper}>
        <Button
          variant="outlined"
          onClick={handleSaveEmployeeEmployment}
          className={ButtonStyle.CsubmitBtn}
        >
          Save
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          onClick={handleEmploymentClose}
          className={ButtonStyle.CcancelBtn}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>

    {/* Benefits Modal */}
    <Dialog
      open={openBenefitsModal}
      onClose={handleBenefitClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={ModalStyles.empDataModal}
      maxWidth="lg"
    >
      <DialogTitle id="alert-dialog-title">
        Edit Employee Benefits
      </DialogTitle>
      <DialogContent className={ModalStyles.CustomTabsWrapper}>

        {fetchedBenefitsData !== undefined ? (
          <form noValidate autoComplete="off" className="grid">
            <EmployeeBenefits fetchedData={fetchedBenefitsData} ref={benefitsRef} employee={props.employee} handleSaveEmployeeBenefit={handleSaveEmployeeBenefit}></EmployeeBenefits>
          </form>
        ) : (
          <h3>No Data Available</h3>
        )}
      </DialogContent>
      <DialogActions className={ButtonStyle.buttonWrapper}>
        <Button
          variant="outlined"
          onClick={handleAddEmployeeBenefit}
          className={ButtonStyle.CsubmitBtn}
        >
          Add Benefit
        </Button>
        {/* 
            <Button
              variant="outlined"
              onClick={handleSaveEmployeeBenefit}
              className={ButtonStyle.CsubmitBtn}
            >
              Save
            </Button> */}

        <Button
          variant="outlined"
          color="secondary"
          onClick={handleBenefitClose}
          className={ButtonStyle.CcancelBtn}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>


    {/* Add Benefits Modal */}
    <Dialog
      open={openAddBenefitsModal}
      onClose={handleAddBenefitClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={ModalStyles.empDataModal}
      maxWidth="lg"
    >
      <DialogTitle id="alert-dialog-title">
        Add Employee Benefits
      </DialogTitle>
      <DialogContent className={ModalStyles.CustomTabsWrapper}>

        {fetchedBenefitsData !== undefined ? (
          <form noValidate autoComplete="off" className="grid">
            <AddEmployeeBenefits fetchedData={fetchedAddBenefitsData} ref={addBenefitsRef} hwBenefitDate={props.hwBenefitDate} employee={props.employee} ></AddEmployeeBenefits>
          </form>
        ) : (
          <h3>No Data Available</h3>
        )}
      </DialogContent>
      <DialogActions className={ButtonStyle.buttonWrapper}>
        <Button
          variant="outlined"
          onClick={handleSaveAddEmployeeBenefit}
          className={ButtonStyle.CsubmitBtn}
        >
          Save
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          onClick={handleAddBenefitClose}
          className={ButtonStyle.CcancelBtn}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  </>;
}

export default EmployeeBenefitsMenu;
